module.exports = __webpack_public_path__ + "static/media/hero-pattern.30796976.png";